export default __webpack_public_path__ + "static/favicon-2e24b2c9e5b75fd836fbafe0d68aa1a4.png";